import React from 'react';

import { makeStyles, Theme } from '@material-ui/core/styles';

import { Button, PriceTag } from '../../../../../components/atoms';
import { Hidden } from '../../../../../components/layouts';
import * as Api from '../../../../../weborder/Api';
import { ToCurrency } from '../../../../../weborder/BasketControl';

type Props = {
  currency: Api.Currency;
  currentLanguage: string;
  disabled?: boolean;
  loading?: boolean;
  noPaymentsAvailable?: boolean;
  onSubmit: (event?: any) => void;
  placeText: string;
  price: number;
  translate: (key: string) => string;
};

const useStyles = makeStyles((theme: Theme) => ({
  buttonPay: {
    width: '100%',

    '& .fd-button': {
      padding: theme.spacing(1.5),

      '& .buttonState': {
        alignItems: 'inherit',
        display: 'flex',
        flexFlow: 'row nowrap',
        justifyContent: 'center',
        width: '100%',
      },
    },
  },

  buttonPrice: {
    display: 'none',
  },

  [theme.breakpoints.up('md')]: {
    buttonPay: {
      '& .fd-button': {
        padding: theme.spacing(2.25),

        '& .buttonState': {
          alignItems: 'center',
          justifyContent: 'space-between',
        },
      },
    },

    buttonPrice: {
      display: 'flex',
      flexDirection: 'column',
      lineHeight: 0.75,
      marginTop: 0,
      textAlign: 'right',

      '& div': {
        minHeight: 'inherit',
      },

      '& .totalCaption': {
        fontSize: theme.typography.pxToRem(10),
        fontWeight: theme.typography.fontWeightMedium,
      },
    },
  },
}));

type ButtonType = 'default' | 'disabled' | 'loading';

export function ButtonPay(props: Props): JSX.Element {
  const {
    currency,
    currentLanguage,
    disabled,
    loading,
    noPaymentsAvailable,
    onSubmit,
    placeText,
    price,
    translate,
  } = props;

  const classes = useStyles();

  const getButtonStatus = (): ButtonType => {
    if (loading) {
      return 'loading';
    }

    if (noPaymentsAvailable || disabled) {
      return 'disabled';
    }

    return 'default';
  };

  const localisedPrice = ToCurrency(price, currency, currentLanguage);

  const handleOnClick = (): void => {
    if (!disabled && !loading) {
      onSubmit();
    }
  };

  return (
    <div className={classes.buttonPay}>
      <Button
        data-fd="checkout-place-order"
        fullWidth
        onClick={handleOnClick}
        status={getButtonStatus()}
      >
        <div>{placeText}</div>

        <div className={classes.buttonPrice}>
          <Hidden smDown>
            <span className="totalCaption">
              {translate('PaymentOptions_TOTAL')}
            </span>
          </Hidden>

          <PriceTag localisedPrice={localisedPrice} translate={translate} />
        </div>
      </Button>
    </div>
  );
}
